import { render } from "./WhereToGoPage.vue?vue&type=template&id=f640cba0&scoped=true"
import script from "./WhereToGoPage.vue?vue&type=script&lang=js"
export * from "./WhereToGoPage.vue?vue&type=script&lang=js"

import "./WhereToGoPage.vue?vue&type=style&index=0&id=f640cba0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f640cba0"]])

export default __exports__